<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      Nominativo
    </div>
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">

        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Cognome" id="Cognome" matInput placeholder="Cognome" [readonly]="data.idRichiestaIscrizioneNominativo >0">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Nome" id="Nome" matInput placeholder="Nome" [readonly]="data.idRichiestaIscrizioneNominativo >0">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Email" id="Email" matInput placeholder="E-mail">
              <mat-hint>Email: sarà lo username per accedere all'area privata</mat-hint>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field>
              <mat-select placeholder="Ruolo" formControlName="idRuolo"
                          required
                          
                          id="idRuolo">
                <mat-option *ngFor="let obj of lstRuolo" [value]="obj.idRuolo">
                  {{obj.DescrizioneRuolo}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- <div class="col-md-4">
      <mat-form-field class="full-width">
        <input formControlName="Fascia" id="Fascia" matInput placeholder="Fascia">
      </mat-form-field>
    </div>
    -->
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <mat-select [disabled]="data.idRichiestaIscrizioneNominativo >0"
                          placeholder="Settore Scientifico Disciplinare - S.S.D." formControlName="idSettoreScientifico"
                          id="idSettoreScientifico">
                <mat-option *ngFor="let obj of lstSettoreScientifico" [value]="obj.idSettoreScientifico">
                  {{obj.SettoreScientificoDescrizione}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input [readonly]="data.idRichiestaIscrizioneNominativo >0" formControlName="CodiceFiscale" id="CodiceFiscale" matInput placeholder="Codice Fiscale">
            </mat-form-field>
          </div>

        </div>


       
        <div mat-dialog-actions>
          <button mat-raised-button color="primary"
                  (click)="btnAnnulla()">
            Annulla
          </button>
          <button *ngIf="!data.idRichiestaIscrizioneNominativo" mat-raised-button color="primary"
                  (click)="btnSalva()"
                  cdkFocusInitial>
            Salva e Aggiungi
          </button>
          <button *ngIf="data.idRichiestaIscrizioneNominativo>0" mat-raised-button color="primary"
                  (click)="btnSalvaEmail()"
                  cdkFocusInitial>
            Salva (*modifica consentita solo nel campo email e ruolo)
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
<style>
  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }
  /* .full-width {
      width: 100%;
    }*/
</style>

